
export const data = [
    {
        title: 'Transport',
        options: [
            { title: 'Public Transport' },
            { title: 'Main Roads' },
            { title: 'Bicycle' },
        ]
    },
    {
        title: 'Amenities',
        options: [
            { title: 'Shopping' },
            { title: 'Dining' },
            { title: 'Entertainment' },
            { title: 'Education' },
            { title: 'Health' },

        ]
    }
];